
















import { Component, Prop, Vue } from 'vue-property-decorator'
import xDialog from '@finance/ssvue/src/components/x-dialog/index.vue'
import RedPacketBags from './red-packet-bags.vue'

@Component({
  name: 'prize-dialog',
  components: {
    xDialog,
    RedPacketBags
  }
})
export default class PrizeDialog extends Vue {
  @Prop() item!: any[];
  @Prop(Number) activeIndex!: number;
  @Prop(Boolean) value!: boolean;
  rainStyle: any[] = []
  rainNums = 40
  show = false
  finishNum = 0
  mounted() {
    // this.setRainPlayStyle()
  }
  close() {
    this.$emit('input', false)
    this.$Collect.trackEvent('2020双12红包领取弹窗_关闭按钮', {}, {
      page_name: '红包领取弹窗'
    })
  }
  // setRainPlayStyle() {
  //   const rainStyle = []
  //   const color = [
  //     '#FF2216',
  //     '#fe4530',
  //     '#ed7d31',
  //     '#ebc456',
  //     '#ffffff',
  //     '#31c8ed',
  //     '#c9fe30',
  //     '#AA7CFB',
  //     '##FF1F10',
  //     '#EAB42F',
  //     '#EAB42F',
  //     '#EAB42F'
  //   ]
  //   for (let i = 0; i < this.rainNums; i++) {
  //     const clrRandom = Math.round(Math.random() * 8)
  //     const leftRandom = Math.round(Math.random() * 100)
  //     const heightRandom = Math.round(Math.random() * 100) + 5
  //     const degRandom = Math.round(Math.random() * 270)
  //     const trackStyle = {
  //       left: `${leftRandom}%`,
  //       height: `${heightRandom}%`,
  //     }
  //     const dotStyle = {
  //       backgroundColor: color[clrRandom],
  //       transform: `rotate(${degRandom}deg)`,
  //     }
  //     rainStyle.push({ trackStyle, dotStyle })
  //   }
  //   this.rainStyle = rainStyle
  // }
}
